import { render, staticRenderFns } from "./Garcom.vue?vue&type=template&id=092c2e17&scoped=true&"
import script from "./Garcom.vue?vue&type=script&lang=js&"
export * from "./Garcom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092c2e17",
  null
  
)

export default component.exports